var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 1.75H5.25C5.57217 1.75 5.83333 2.01117 5.83333 2.33333V5.25C5.83333 5.57217 5.57217 5.83333 5.25 5.83333H2.33333C2.01117 5.83333 1.75 5.57217 1.75 5.25V2.33333C1.75 2.01117 2.01117 1.75 2.33333 1.75Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75008 1.75H11.6667C11.9889 1.75 12.2501 2.01117 12.2501 2.33333V5.25C12.2501 5.57217 11.9889 5.83333 11.6667 5.83333H8.75008C8.42792 5.83333 8.16675 5.57217 8.16675 5.25V2.33333C8.16675 2.01117 8.42792 1.75 8.75008 1.75Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75008 8.16406H11.6667C11.9889 8.16406 12.2501 8.42523 12.2501 8.7474V11.6641C12.2501 11.9862 11.9889 12.2474 11.6667 12.2474H8.75008C8.42792 12.2474 8.16675 11.9862 8.16675 11.6641V8.7474C8.16675 8.42523 8.42792 8.16406 8.75008 8.16406Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 8.16406H5.25C5.57217 8.16406 5.83333 8.42523 5.83333 8.7474V11.6641C5.83333 11.9862 5.57217 12.2474 5.25 12.2474H2.33333C2.01117 12.2474 1.75 11.9862 1.75 11.6641V8.7474C1.75 8.42523 2.01117 8.16406 2.33333 8.16406Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactIcon);
export default __webpack_public_path__ + "static/media/compact-icon.b02a4e734edab872a5fd7b1091ac0822.svg";
export { ForwardRef as ReactComponent };